@use "variables" as *;

.itemDiv {
  width: 100%;
  padding-left: $spacing-m;
  padding-right: $spacing-m;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.itemWithDetailImage {
  padding-top: 0 !important;
  padding-right: 0 !important;
  padding-bottom: 0 !important;
}

.detailImageContainer {
  display: flex;
  position: absolute;
  height: 52px;
  width: 52px;
  right: 0;
}

.detailImage {
  aspect-ratio: 1;
  height: 100%;
}

.listItemText {
  flex-shrink: 0 !important;
  word-wrap: anywhere;
}

.loadingDiv {
  display: flex;
  flex-grow: 100;
  align-items: flex-start;
  margin-left: $spacing-s;
}

.titlePrimary {
  font-size: $fontSize-m !important;
}

.titleSecondary {
  font-size: $fontSize-xs !important;
  font-weight: normal !important;
}

.detailPrimary {
  font-size: $fontSize-m !important;
  font-weight: bold !important;
  font-variant: tabular-nums !important;
  white-space: pre-wrap !important;
}

.detailSecondary {
  font-size: $fontSize-xs !important;
  font-weight: normal !important;
}
